import React from "react";
import { Link } from "react-router-dom";

const SUPPORT = "moncommerce68@gmail.com";

function Page({ title, children, testid }) {
  return (
    <div className="mx-auto max-w-3xl px-6 lg:px-10 py-20" data-testid={testid}>
      <div className="label-uppercase mb-2">Mon Commerce 68</div>
      <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-medium mb-8">{title}</h1>
      <div className="prose prose-stone max-w-none text-foreground/85 space-y-4 leading-relaxed text-base">{children}</div>
      <div className="mt-12 text-sm"><Link to="/" className="text-primary underline">← Accueil</Link></div>
    </div>
  );
}

export function MentionsLegales() {
  return (
    <Page title="Mentions légales" testid="page-mentions">
      <p><strong>Éditeur du site :</strong> STEGO DAMIEN, exerçant sous le nom commercial <strong>Digital Corp France</strong> — siège social : 9 rue André Koechlin-Dollfus, 68200 Mulhouse, France.</p>
      <p><strong>Contact :</strong> <a href={`mailto:${SUPPORT}`}>{SUPPORT}</a></p>
      <p><strong>Directeur de la publication :</strong> Damien Stego.</p>
      <p><strong>Hébergement :</strong> Emergent (emergent.sh).</p>
      <p>Le site moncommerce68.fr est un annuaire d'entreprises locales du Haut-Rhin proposant un service freemium aux commerçants, artisans et prestataires.</p>
      <p>Les marques, logos et contenus présents sur le site appartiennent à leurs détenteurs respectifs. Toute reproduction sans autorisation est interdite.</p>
    </Page>
  );
}

export function CGU() {
  return (
    <Page title="Conditions Générales d'Utilisation" testid="page-cgu">
      <p>L'utilisation du site implique l'acceptation pleine et entière des présentes conditions.</p>
      <p><strong>Objet :</strong> permettre la consultation publique d'un annuaire d'entreprises du Haut-Rhin et la gestion par leurs propriétaires d'une fiche partenaire.</p>
      <p><strong>Inscription & comptes :</strong> l'authentification se fait par lien magique envoyé par email. Les utilisateurs sont responsables de la sécurité de leur boîte mail.</p>
      <p><strong>Contenu :</strong> les commerçants partenaires sont seuls responsables des informations publiées sur leur fiche. Toute information inexacte ou trompeuse peut entraîner la suspension de la fiche.</p>
      <p><strong>Avis clients :</strong> tous les avis sont modérés. Les avis injurieux, faux ou diffamatoires sont supprimés.</p>
      <p><strong>Disponibilité :</strong> le service est fourni "en l'état" et nous nous réservons le droit d'effectuer toute opération de maintenance.</p>
    </Page>
  );
}

export function CGV() {
  return (
    <Page title="Conditions Générales de Vente" testid="page-cgv">
      <p>Les CGV régissent les abonnements payants Mon Commerce 68 — Premium et Premium IA.</p>
      <p><strong>Tarifs :</strong> 14,99 € TTC/mois (Premium) et 29,99 € TTC/mois (Premium IA). Sans engagement.</p>
      <p><strong>Paiement :</strong> via PayPal Business (prélèvement mensuel automatique).</p>
      <p><strong>Résiliation :</strong> à tout moment depuis l'espace partenaire ou depuis votre compte PayPal. La résiliation prend effet à la fin de la période en cours.</p>
      <p><strong>Droit de rétractation :</strong> conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux services pleinement exécutés avant la fin du délai de 14 jours dès lors que l'exécution a commencé avec votre accord. Vous pouvez toutefois résilier sans frais à tout moment.</p>
      <p><strong>Facturation :</strong> les reçus de paiement sont disponibles depuis votre compte PayPal et envoyés automatiquement par email.</p>
      <p><strong>Réclamations :</strong> <a href={`mailto:${SUPPORT}`}>{SUPPORT}</a></p>
    </Page>
  );
}

export function RGPD() {
  return (
    <Page title="Politique de confidentialité (RGPD)" testid="page-rgpd">
      <p>Mon Commerce 68 traite vos données personnelles dans le strict respect du Règlement (UE) 2016/679 (RGPD).</p>
      <p><strong>Responsable du traitement :</strong> STEGO DAMIEN — 9 rue André Koechlin-Dollfus, 68200 Mulhouse.</p>
      <p><strong>Données collectées :</strong> email (authentification), nom et coordonnées professionnelles (fiche partenaire), données de paiement (gérées par PayPal — non stockées chez nous).</p>
      <p><strong>Finalités :</strong> fourniture du service d'annuaire, mise en relation B2C/B2B, facturation des abonnements, statistiques d'audience anonymisées.</p>
      <p><strong>Conservation :</strong> tant que votre compte est actif, puis 3 ans après dernière connexion.</p>
      <p><strong>Vos droits :</strong> accès, rectification, effacement, portabilité, opposition. Contactez <a href={`mailto:${SUPPORT}`}>{SUPPORT}</a>.</p>
      <p><strong>Hébergement :</strong> Union Européenne (Emergent.sh).</p>
      <p>Vous pouvez introduire une réclamation auprès de la CNIL (cnil.fr).</p>
    </Page>
  );
}

export function Cookies() {
  return (
    <Page title="Politique des cookies" testid="page-cookies">
      <p>Trois catégories de cookies sont utilisées sur ce site :</p>
      <ul className="list-disc pl-6">
        <li><strong>Essentiels (toujours actifs) :</strong> session de connexion, préférence de langue, sécurité.</li>
        <li><strong>Analytiques (consentement requis) :</strong> mesure d'audience anonymisée, optimisation du contenu.</li>
        <li><strong>IA (déclarés) :</strong> ces cookies signalent que des services IA peuvent être utilisés pour améliorer la recherche locale.</li>
      </ul>
      <p>Vous pouvez modifier votre choix à tout moment depuis la bannière en bas de page.</p>
    </Page>
  );
}

export function About() {
  return (
    <Page title="À propos" testid="page-about">
      <p>Mon Commerce 68 est l'annuaire premium des entreprises du Haut-Rhin. Notre mission : transformer la visibilité locale en opportunités clients pour les commerçants, artisans et prestataires de notre département.</p>
      <p>Édité par <strong>STEGO DAMIEN — Digital Corp France</strong>, basé à Mulhouse, le projet conjugue technologie de pointe (IA multilingue FR/EN/DE pour capter le trafic frontalier suisse et allemand) et ancrage local profond.</p>
      <p>Contact partenariats : <a href="mailto:digitalcorpfrance@gmail.com">digitalcorpfrance@gmail.com</a> · Support : <a href={`mailto:${SUPPORT}`}>{SUPPORT}</a>.</p>
    </Page>
  );
}
